module.exports = __webpack_public_path__ + "img/saba_aya_yes.a7767d58.png";